'use client';

import { clientOnlyDynamic } from '@/lib/client-only-dynamic';
import { CommentListSkeleton } from '@/components/PageSkeletons';

const CommentThread = clientOnlyDynamic(() => import('./CommentThread'), { loading: () => (
    <div className="rounded-2xl border border-slate-200/90 bg-white/95 px-3 py-2 dark:border-slate-700 dark:bg-slate-950/80 sm:px-4">
      <CommentListSkeleton count={3} />
    </div>
  ),
});

interface CommentThreadWrapperProps {
  targetType: 'article' | 'gallery' | 'post' | 'video';
  targetId: number;
  onTotalCountChange?: (count: number) => void;
}

export default function CommentThreadWrapper({
  targetType,
  targetId,
  onTotalCountChange,
}: CommentThreadWrapperProps) {
  const id = Number(targetId);
  if (!Number.isFinite(id) || id < 1) {
    return (
      <div className="rounded-2xl border border-amber-200/90 bg-amber-50/90 p-4 text-sm text-amber-900 dark:border-amber-900/50 dark:bg-amber-950/40 dark:text-amber-100">
        Yorumlar bu içerik için yüklenemiyor (geçersiz içerik kimliği).
      </div>
    );
  }
  return (
    <CommentThread
      targetType={targetType}
      targetId={id}
      onTotalCountChange={onTotalCountChange}
    />
  );
}

